<script setup lang="ts">
import { mdiChevronUp } from "@mdi/js";
import NavIcon from "~/components/layout/Nav/NavIcon.vue";
import { IEvent } from "~/types/sports/event";

interface Props {
	title: string;
	defaultOpen: boolean;
	event?: IEvent;
	regionId?: string;
}
const props = defineProps<Props>();
const isOpen = ref(props.defaultOpen);
const toggleAccordion = () => {
	isOpen.value = !isOpen.value;
};
</script>

<template>
	<div class="w-full py-1">
		<div
			@click="toggleAccordion"
			class="flex justify-between items-center px-1 py-2 text-white cursor-pointer w-full gap-1 bg-dark-800 text-light-50 relative text-xs leading-none'"
			:class="!isOpen ? 'rounded-lg' : 'rounded-t-lg'"
		>
			<div class="flex items-center">
				<NavIcon
					v-if="regionId"
					:width="24"
					:height="24"
					:src="`/icons/regions-leagues-flags/${regionId.toLowerCase()}-circular.svg`"
					:alt="regionId"
					fallback="/icons/regions-leagues-flags/default-circular.svg"
					class="flex-shrink-0"
				/>
				<div class="font-bold px-1">
					{{ title }}
				</div>
			</div>

			<div class="absolute -translate-y-1/2 right-2 top-1/2">
				<UiIcon :class="['z-10 w-6 h-6 fill-light-50 transition-all', !isOpen && 'rotate-180']" :path="mdiChevronUp" />
			</div>
		</div>

		<div v-if="isOpen" class="rounded-b-lg bg-light-300 dark:bg-dark-800">
			<slot name="content" />
		</div>
	</div>
</template>
